import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const FormGrid = styled.div`
  display: grid;
  grid-template: 1fr / 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 16px;
`;

export const FormFieldWrapper = styled.div`
  grid-column-end: span ${({ span }) => span || 1};
`;

export const FormLabel = styled(typography.P2RegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey600};
`;

export const FormTextInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.grey006};
  border-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey005};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey005};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey005};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey005};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.grey006};
    outline: none;
  }
`;

export const FormValidationError = styled(typography.P2RegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redDark};
`;
